<script>
import socials from "@/data/socials";
export default {
  name: "Discord",

  data: () => ({
    discordUrl: socials.discordUrl,
  }),

  methods: {
    reportConversion() {
      if (typeof window.gtag_report_conversion === "function") {
        window.gtag_report_conversion(this.discordUrl);
      }
    },
    openDiscord() {
      window.open(this.discordUrl, "_blank");
    },
  },
};
</script>

<template>
  <div class="page-background">
    <div class="container">
      <h1>Join our Vibrant</h1>
      <h2>Discord Community!</h2>
      <a
        :href="discordUrl"
        target="_blank"
        class="banner position-relative"
        @click="reportConversion"
      >
        <v-btn color="gold" class="border-doubled join-button" @click.stop.prevent="openDiscord()"> Join Now </v-btn>
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.join-button {
  position: absolute;
  top: 85%;
  left: 48%;
  transform: translateX(-50%) translateY(-50%);
}

.page-background {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-image: url("/images/backgrounds/dropping-coins.png");
  background-size: cover;
}

.container {
  padding-top: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 80%;
  color: white;

  container-name: discord;
  container-type: inline-size;

  h1,
  h2 {
    font-size: 72px;
    color: white;
    text-align: center;
  }

  h2 {
    margin-bottom: 20px;
  }

  .banner {
    display: block;
    border-radius: 20px;
    width: 100%;
    max-width: 1200px;
    height: 500px;
    background-image: url("/images/banners/discord.png");
    background-position: top center;
  }

  @container discord (width < 820px) {
    .banner {
      background-image: url("/images/banners/discord-mini.png") !important;
      height: 100% !important;
      background-size: contain !important;
      min-height: 300px;
    }
  }

  @media (max-width: 960px) {
    width: 100%;

    h1 {
      margin-top: 55px;
    }

    h1,
    h2 {
      font-size: 36px;
    }
  }
}
</style>
